<template>
  <div>
    <router-view :key="componentKey" />
    <div class="maximum-width">
      <link-index></link-index>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import FooterBottom from "@/components/Footer";
import LinkIndex from "@/components/LinkIndex";
export default {
  name: "OrgLayout",
  components: {
    FooterBottom,
    LinkIndex,
  },
  data(){
    return{
      componentKey:1000
    }
  },
   methods: {
      getData(){
        this.componentKey += 1
      }
   }
};
</script>

<style>
</style>